exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../node_modules/css-loader/index.js!quill/dist/quill.snow.css"), "");

// module
exports.push([module.id, ".ql-snow .ql-tooltip[data-v-1dbb5118] {\n  left: 0px !important;\n}", ""]);

// exports
